import { useEffect } from "react";
import Lenis from "lenis";
import { Toaster } from "sonner";
import "@/App.css";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { Ribbon } from "@/components/site/Ribbon";
import { Tjenester } from "@/components/site/Tjenester";
import { Leverandorer } from "@/components/site/Leverandorer";
import { Service } from "@/components/site/Service";
import { OmOss } from "@/components/site/OmOss";
import { Kontakt } from "@/components/site/Kontakt";
import { Footer } from "@/components/site/Footer";

function App() {
  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    window.__lenis = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      delete window.__lenis;
    };
  }, []);

  return (
    <div className="App bg-paper">
      <div className="noise-overlay" />
      <Toaster
        position="bottom-right"
        toastOptions={{
          style: {
            borderRadius: 0,
            border: "1px solid rgba(0,0,0,0.1)",
            fontFamily: "IBM Plex Sans, sans-serif",
          },
        }}
      />
      <Header />
      <main>
        <Hero />
        <Ribbon />
        <Tjenester />
        <Leverandorer />
        <Service />
        <OmOss />
        <Kontakt />
      </main>
      <Footer />
    </div>
  );
}

export default App;
